// removed by extract-text-webpack-plugin
module.exports = {"main":"_1qcexlhptLqZBEg_8CbQJ1","video":"_2URe4xOV3Xtq7SSE29nGd5","hidden":"_1N0frGsdqClr6UBFCk_O-o","image":"_29mYp0XRQXeSjhR7w814Tr","loading":"_1z9WAQJ1ComPxdqYBZ9ToP"};


//////////////////
// WEBPACK FOOTER
// ./src/projects/easy/public/Comps/basic/Video.scss
// module id = 693
// module chunks = 12